export default __webpack_public_path__ + "static/media/edit-rsvp-btn-bg-4x.7cd45770.png";